import React from "react";
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

const VistoLogoIcon = ({ height, width, style }) => {
  return (
    <SvgIcon viewBox="0 0 96 31" style={{ height, width, ...style }}>
      <path
        d="M90.5989 3.73311L88.0356 6.37774C87.7813 6.59134 87.4253 6.73374 87.0388 6.73374C86.1844 6.73374 85.5029 6.05224 85.5029 5.19783C85.5029 4.65873 85.7572 4.27221 86.042 4.01791L89.6122 0.732473C89.8665 0.518868 90.2225 0.376465 90.609 0.376465C91.0057 0.376465 91.3617 0.518868 91.6059 0.732473L95.1761 4.01791C95.4609 4.27221 95.7152 4.65873 95.7152 5.19783C95.7152 6.05224 95.0337 6.73374 94.1793 6.73374C93.7826 6.73374 93.4266 6.59134 93.1825 6.37774L90.5989 3.73311Z"
        fill="#00AFAB"
      />
      <path
        d="M17.7902 13.9148L10.7412 29.4775C10.4463 29.986 9.90716 30.3522 9.24601 30.3522C8.59502 30.3522 8.18816 29.986 7.90335 29.4775L0.701825 13.9148C0.589937 13.7012 0.48822 13.4469 0.48822 13.152C0.48822 12.3179 1.21041 11.6567 2.12586 11.6567C2.81753 11.6567 3.35662 12.0941 3.6516 12.6332L9.24601 25.0325L14.8404 12.6332C15.1354 12.0839 15.6745 11.6567 16.3662 11.6567C17.2714 11.6567 18.0038 12.3077 18.0038 13.152C18.014 13.4469 17.9021 13.7012 17.7902 13.9148Z"
        fill="#595A5C"
      />
      <path
        d="M24.6662 4.57715C25.7241 4.57715 26.5581 5.41122 26.5581 6.46907C26.5581 7.52693 25.7241 8.361 24.6662 8.361C23.6084 8.361 22.7743 7.52693 22.7743 6.46907C22.7743 5.41122 23.6084 4.57715 24.6662 4.57715Z"
        fill="#00AFAB"
      />
      <path
        d="M23.0286 13.3046C23.0286 12.3994 23.7508 11.667 24.6662 11.667C25.5715 11.667 26.3038 12.3994 26.3038 13.3046V28.7147C26.3038 29.6199 25.5715 30.3523 24.6662 30.3523C23.7609 30.3523 23.0286 29.6199 23.0286 28.7147V13.3046Z"
        fill="#595A5C"
      />
      <path
        d="M44.7349 13.8437C44.9892 14.1387 45.2842 14.6066 45.2842 15.2271C45.2842 15.8781 44.8163 16.6104 43.8296 16.6104C43.2092 16.6104 42.8837 16.2849 42.5175 15.9899C42.0089 15.4102 41.0223 14.5354 39.2422 14.5354C36.7298 14.5354 36.0076 15.8781 36.0076 16.824C36.0076 20.5367 46.0369 18.1362 46.0369 25.0732C46.0369 27.6161 43.7483 30.3421 39.2422 30.3421C34.665 30.3421 32.8849 27.6161 32.59 27.3618C32.3764 27.077 32.1221 26.7414 32.1221 26.2328C32.1221 25.3987 32.7019 24.7782 33.6478 24.7782C34.0852 24.7782 34.5531 24.9919 34.8481 25.3987C35.0312 25.6123 36.1907 27.4737 39.2422 27.4737C41.246 27.4737 42.6599 26.5685 42.6599 25.0732C42.6599 21.4013 32.6307 23.5068 32.6307 16.824C32.6307 14.393 34.7769 11.667 39.2422 11.667C42.4056 11.667 44.1551 13.1521 44.7349 13.8437Z"
        fill="#595A5C"
      />
      <path
        d="M52.9536 11.9211V7.85248C52.9536 6.9472 53.6758 6.21484 54.5912 6.21484C55.4965 6.21484 56.2288 6.93703 56.2288 7.85248V11.9211H60.0432C60.8468 11.9211 61.4571 12.5721 61.4571 13.335C61.4571 14.0979 60.8366 14.7489 60.0432 14.7489H56.2288V23.4049C56.2288 25.6223 57.9377 27.4431 60.0432 27.4431C60.8468 27.4431 61.4978 28.0941 61.4978 28.8976C61.4978 29.7012 60.8773 30.3522 60.0432 30.3522C56.117 30.3522 52.9536 27.26 52.9536 23.4049V14.7489H51.8652C51.0617 14.7489 50.4514 14.0979 50.4514 13.335C50.4514 12.5721 51.0718 11.9211 51.8652 11.9211H52.9536Z"
        fill="#595A5C"
      />
      <path
        d="M75.0159 11.667C80.3255 11.667 84.5061 15.6339 84.5061 21.0046C84.5061 26.3854 80.3255 30.3116 75.0159 30.3116C69.7063 30.3116 65.5258 26.3854 65.5258 21.0046C65.5359 15.6238 69.7165 11.667 75.0159 11.667ZM75.0159 27.2906C78.3624 27.2906 80.9765 24.6765 80.9765 21.0046C80.9765 17.3326 78.3624 14.6778 75.0159 14.6778C71.6694 14.6778 69.0553 17.3326 69.0553 21.0046C69.0553 24.6765 71.6796 27.2906 75.0159 27.2906Z"
        fill="#595A5C"
      />
    </SvgIcon>
  );
};

export default VistoLogoIcon;

VistoLogoIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};

VistoLogoIcon.defaultProps = {
  height: 18,
  width: 57
};
